exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".print-dialog .dg-main-content{padding:0}.print-dialog .dg-title{background-color:#052360}.print-dialog .dg-body{padding:15px}.print-dialog .spinner{padding:0 13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2cacfe04","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Dialogs/Print.vue
// module id = R7xR
// module chunks = 1